import React from "react";
const Input = ({
  label = "",
  onBlur,
  onChange,
  value,
  error,
  errorlabel,
  placeholder,
  type,
  maxLength,
  disabled,
  autoComplete,
}) => {
  return (
    <div className={"input-item global " + (error ? " error" : "")}>
      <label className={"control-label " + (error ? " error" : "")}>
        <span>{error ? errorlabel : label}</span>
        <input
          type={type}
          placeholder={placeholder}
          className="form-control"
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          maxLength={maxLength}
          disabled={disabled}
          autoComplete={autoComplete}
        />
      </label>
    </div>
  );
};
export default Input;
